import { Permission } from "@edgetier/watchtower-types";

export * from "./permission-details";
export * from "./permission-details.types";
export * from "./permission-groups";
export * from "./permission-groups.types";

/**
 * Every permission the front end knows about. Used where the full set of a user's permissions is needed, rather than
 * a check against one specific permission.
 */
export const ALL_PERMISSIONS = Object.values(Permission).filter(
    (value): value is Permission => typeof value === "number"
);

export const HOME_PERMISSIONS = [
    Permission.ViewAnomalies,
    Permission.ViewExplore,
    Permission.ViewLive,
    Permission.ViewCustomerInsights,
];

/**
 * Permissions that each give access to the Agent Activity page. A user needs any one of them.
 */
export const AGENT_ACTIVITY_PERMISSIONS = [
    Permission.ViewAgent,
    Permission.ViewAgentDetails,
    Permission.ViewOwnAgentActivity,
];
